import { TokenClaims } from '@azure/msal-common';

export type IdTokenClaims = TokenClaims & {
	[key: string]: string | number | string[] | object | undefined | unknown;
};

export interface WaterIQClaims extends IdTokenClaims {
	exp: number;
	nbf: number;
	ver: string;
	iss: string;
	sub: string;
	aud: string;
	acr: string;
	nonce: string;
	iat: number;
	auth_time: number;
	email: string;
	name: string;
	contactId: string;
	externalId: string;
	tid: string;
	privilegelvl?: WaterIQPrivilegeLevel;
	isapprovedexternaluser?: boolean;
	TUO_sub?: string; // only at myGovID login
	given_name?: string; // only at myGovID login
	family_name?: string; // only at myGovID login
	birthdate?: string; // only at myGovID login
	TUO_acr?: string; // only at myGovID login
	WaterIQ_Note?: string; // only at myGovID login
	wateriq_usertype?: WaterIQUserType[]; // only at myGovID login
}

export enum WaterIQUserType {
	DQP = 'DQP',
	WEH = 'WEH',
}

export enum WaterIQPrivilegeLevel {
	IP1 = 'ip1',
	IP2 = 'ip2',
	IP3 = 'ip3',
}
